export enum DataDogRegion {
  US1 = "US1",
  US3 = "US3",
  US5 = "US5",
  EU1 = "EU1",
  GOV = "US1-FED",
}
